interface ResponseData {
  code: number;
  data: any;
  message: string;
}

export class Http {
  static async post<T>(url: string, data: any, host?: string): Promise<T> {
    const postUrl = host ? host + url : this.getUrl(url);
    const response = await fetch(postUrl, {
      method: 'POST',
      headers: this.getHeaders(),
      body: JSON.stringify(data),
    });
    const res: ResponseData = await response.json();
    if (response.ok && res.code === 0) {
      return res.data;
    } else {
      throw new Error(res.message || 'Request failed');
    }
  }

  static async get<T>(url: string, params: any = {}, host?: string): Promise<T> {
    const queryString = new URLSearchParams(params).toString();
    const base = host ? host + url : this.getUrl(url);
    const getUrl = queryString.length > 0 ? `${base}?${queryString}` : base;
    const response = await fetch(getUrl, {
      method: 'GET',
      headers: this.getHeaders(),
    });
    const res: ResponseData = await response.json();
    if (response.ok && res.code === 0) {
      return res.data;
    } else {
      throw new Error(res.message || 'Request failed');
    }
  }

  static getUrl(url: string): string {
    return this.getHost() + url;
  }

  static getHost(): string {
    return 'https://ncus.joyway.net';
  }

  static getHeaders(): Record<string, string> {
    return {
      'Content-Type': 'application/json',
      // Add more custom headers here if needed
    };
  }
}
